<template>
  <div>
    <!-- HEADER -->
    <section id="lp-header" class="py-5">
      <div class="container text-center d-lg-flex align-items-lg-center justify-content-center py-5">
        <div>
          <div>
            <h2 class="font-size-xLarge font-weight-bold">EVENTO #05 - AMOR</h2>
          </div>
          <p class="mb-lg-0">Publique uma história sobre amor e concorra a uma <strong>Instax Mini 9</strong> e muitos outros prêmios!</p>
        </div>
      </div>
    </section> <!-- END HEADER -->
    <!-- BUTTONS -->
    <section id="buttons" class="text-center">
      <div>
        <Button
          class="btn btn-color3 mr-3"
          @click="toggleTheme"
        >
          Entenda o tema
        </Button>
        <router-link
          :to="{ name: 'posts.create', query: { tags: 'meuamor' } }"
          target="_blank"
          class="btn btn-primary"
          v-if="authenticated"
        >
          Escrever texto
        </router-link>
        <Button
          class="btn btn-primary"
          v-b-modal.auth-modal
          v-else
        >
          Escrever texto
        </Button>
      </div>
    </section> <!-- END BUTTONS -->
    <!-- ABOUT THEME -->
    <section
      id="about-theme"
      ref="aboutTheme"
      :class="{
        hidden: !aboutThemeVisible
      }"
    >
      <div class="container py-5 text-center text-md-left">
        <h2 class="font-size-medium font-weight-bold text-color2">Explicando o Tema</h2>
        <p>Em um momento que precisamos celebrar o amor, a escolha do tema se deu pensando que há datas que envolvem esse sentimento nos meses de maio e junho, como o Dia das Mães, Dia dos Namorados e o mês das noivas. Com esse clima romântico no ar, a Scriv definiu o tema do seu quinto evento: Histórias de Amor.</p>
        <p>O tema vai contemplar textos que contenham histórias de romance, mas também narrativas envolvendo o amor maternal ou fraternal, por exemplo. O importante é que seja uma história de amor, seja qual ela for.</p>

        <h2 class="font-size-medium font-weight-bold text-color2">Qual tipo de texto devo publicar?</h2>
        <p>Deixamos aqui a criatividade correr solta para todos os autores e autoras da Scriv. Vamos aceitar textos narrativos, poemas, contos curtos ou qualquer outro formato existente.</p>
        <p>A história pode ter acontecido com o próprio autor, com um terceiro ou ser uma narrativa completamente inventada, desde que seja uma narrativa envolvendo amor e respeite completamente as regras ao final desta página.</p>
        <h2 class="font-size-medium font-weight-bold text-color2">Exemplos</h2>
        <div class="post-thumbs-listing listing-rowed items-3-per-row mt-4">
          <ul class="list-wrap">
            <li
              class="list-item"
              v-for="(item, index) in items"
              :key="index"
            >
                <PostThumbCard
                  :post="item"
                  linkTarget="_blank"
                />
            </li>
          </ul>
        </div>
        <div class="mt-3 text-center">
          <Button
            class="btn btn-primary"
            @click="toggleTheme"
          >
            Fechar
          </Button>
        </div>
      </div>
    </section> <!-- END ABOUT THEME -->
    <!-- STEPS -->
    <section id="steps" class="mt-3">
      <div class="container py-4">
        <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-between mx-md-auto col-md-11">
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/user_v2.png" alt="Crie perfil" />
            <p>Crie seu perfil <br/>na Scriv</p>
          </div>
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/write_v2.png" alt="Escreva" />
            <p>Escreva <br/>sua história</p>
          </div>
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/tag_v2.png" alt="Tag" />
            <p>Insira a tag<br/><span class="text-color2 font-weight-bold">meuamor</span></p>
          </div>
          <div class="step">
            <img src="/images/events/icons/publish_v2.png" alt="Publique" />
            <p>Clique em<br/>publicar</p>
          </div>
        </div>
      </div>
    </section> <!-- END STEPS -->
    <!-- PRIZES -->
    <div id="prizes">
      <div class="container py-3 text-center">
        <h2 class="font-size-xLarge mb-3"><span class="highlighted highlight-left">Premiações</span></h2>
        <p class="mb-5">A Scriv vai premiar as cinco melhores histórias de amor</p>
        <div class="mx-auto col-md-11 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
          <div class="px-0 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/award-instax.jpg');"></div>
            <span>Instax Mini 9</span>
          </div>
          <div class="px-0 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/award-livros.jpg');"></div>
            <span>Livros Físicos</span>
          </div>
          <div class="px-0 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/award-kits.jpg');"></div>
            <span>Kits Scriv</span>
          </div>
          <div class="px-0 prize-item">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/award-dengo.jpg');"></div>
            <span>Vale Dengo</span>
          </div>
          <div class="px-0 prize-item">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/award-medalha.jpg');"></div>
            <span>Medalha no Perfil</span>
          </div>
        </div>
      </div>
    </div> <!-- END PRIZES -->
    <!-- JUDGES -->
    <section id="judges">
      <div class="container py-4 text-center">
        <h2 class="font-size-xLarge mb-5"><span class="highlighted highlight-left">Jurados</span></h2>
        <div class="mx-auto col-md-11 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
          <div class="col-md-3 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/judge-raffa.jpg');"></div>
            <span class="d-block font-weight-bold">Raffa Fustagno</span>
            <p class="mb-1 font-size-small">Jornalista, blogueira, youtuber <br class="d-none d-lg-block"/>e escritora com mais de 13 livros publicados</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li class="mr-2">
                <a href="https://twitter.com/raffafust" class="link-color2" target="_blank"><i class="fa fa-twitter"></i></a>
              </li>
              <li>
                <a href="https://www.instagram.com/raffafustagno/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/judge-ligia.jpg');"></div>
            <span class="d-block font-weight-bold">Ligia Tiemi</span>
            <p class="mb-1 font-size-small">(Quase) jornalista, <br class="d-none d-lg-block"/>contadora de histórias e romântica incurável</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li class="mr-2">
                <a href="https://twitter.com/ligiatakau" class="link-color2" target="_blank"><i class="fa fa-twitter"></i></a>
              </li>
              <li>
                <a href="https://www.instagram.com/takaulih/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/judge-luis.jpg');"></div>
            <span class="d-block font-weight-bold">Luis Kita</span>
            <p class="mb-1 font-size-small">Artista visual, poeta e fotógrafo, <br class="d-none d-lg-block"/>tendo como diálogo o estudo entre imagem e palavra.</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li>
                <a href="https://www.instagram.com/luiskita/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/05-amor/judge-laura.jpg');"></div>
            <span class="d-block font-weight-bold">Laura Ferrazano</span>
            <p class="mb-1 font-size-small">Jornalista cultural, entusiasta<br class="d-none d-lg-block"/> das artes e assistente de redação no Filmelier</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li class="mr-2">
                <a href="https://twitter.com/lpferrazzano" class="link-color2" target="_blank"><i class="fa fa-twitter"></i></a>
              </li>
              <li>
                <a href="https://www.instagram.com/mnemosine.club/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- RULES -->
    <section id="rules">
      <div class="container py-5 col-md-8">
        <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Regras de participação</h2>
        <ul class="pl-5">
          <li>O texto publicado deve ter, no máximo, 2.200 palavras;</li>
          <li>O participante precisa escrever de um perfil próprio na Scriv, sem utilizar perfil de terceiros;</li>
          <li>O texto publicado precisa ser original e não ter sido publicado em outra plataforma;</li>
          <li>O texto publicado precisar conter a tag <strong class="text-color2">meuamor</strong> e estar em modo público na plataforma;</li>
          <li>Cada autor poderá inscrever no evento quantos textos desejar, mas apenas um texto por autor será premiado nos cinco vencedores;</li>
          <li>Um texto previamente publicado na Scriv pode ser inscrito no evento, desde que não tenha sido inscrito em nenhum outro concurso da nossa plataforma até o momento.</li>
        </ul>
        <div v-show="rulesVisible">
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Condições Gerais</h2>
          <ul class="pl-5">
            <li>O texto publicado precisa respeitar as Regras de Moderação de nossa plataforma;</li>
            <li>Qualquer violação destas regras promoverá a desclassificação automática do texto;</li>
            <li>Qualquer situação não prevista nestas condições será avaliada individualmente;</li>
            <li>Não poderão participar pessoas com relações comerciais ou empregatícias com a Scriv;</li>
            <li>Não poderão participar parentes de 1º grau de qualquer membro da banca de jurados;</li>
            <li>Como o texto pode ser editado, será considerado o texto ativo e público no dia da deliberação dos jurados (conforme calendário abaixo).</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Banca de Jurados</h2>
          <ul class="pl-5">
            <li>Os jurados serão: Raffa Fustagno, Laura Ferrazano, Luis Kita e Ligia Tiemi.</li>
            <li>Os jurados terão igual poder de voto e ordem de grandeza entre si, sem exceções;</li>
            <li>Os jurados não possuem relação direta com os autores e respectivos textos publicados;</li>
            <li>Os jurados não possuem conflitos de interesse em relação ao tema e respectivas premiações.</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Metodologia</h2>
          <ul class="pl-5">
            <li>Todos os textos inscritos passarão por uma pré-banca formada por integrantes da Scriv;</li>
            <li>Os textos selecionados serão lidos por todos os jurados, sem interferência da Scriv;</li>
            <li>Os jurados darão uma nota de 0 a 10 para as categorias: amor/emoção, narrativa e ortografia.</li>
            <li>A nota final de cada texto será formulada por essas notas individuais das categorias;</li>
            <li>Os textos serão então ranqueados pela média das notas, da primeira à quinta colocação.</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Premiações</h2>
          <ul class="pl-5">
            <li>Serão premiados os cinco melhores textos, de acordo com a metodologia acima;</li>
            <li>Apenas um texto por autor poderá figurar entre os cinco textos vencedores;</li>
            <li>Os textos que ficarem em 4º e 5º lugar receberão um livro físico a sua escolha, um kit personalizado da Scriv e uma medalha de premiação no perfil;</li>
            <li>O texto que ficar em 3º lugar receberá um livro físico a sua escolha, um kit personalizado da Scriv, um vale de R$ 35,00 da Dengo Chocolates e uma medalha de premiação no perfil;</li>
            <li>O texto que ficar em 2º lugar receberá um livro físico a sua escolha, um kit personalizado da Scriv, um vale de R$ 50,00 da Dengo Chocolates e uma medalha de premiação no perfil;</li>
            <li>O texto vencedor receberá uma <strong class="text-color2">Instax Mini 9</strong>, um livro físico a sua escolha, um kit personalizado da Scriv, um vale de R$ 80,00 da Dengo Chocolates e uma medalha no perfil;</li>
            <li>Entraremos em contato com os vencedores em até 5 (cinco) dias após a divulgação dos mesmos, pelo email cadastrado na Scriv ou via redes sociais.</li>
          </ul>
        </div>
      </div>
    </section> <!-- END RULES -->
    <div class="text-center read-more-rules position-relative">
      <Button
        class="btn btn-primary"
        @click="rulesVisible = !rulesVisible"
      >
        <span v-if="rulesVisible">Fechar</span>
        <span v-else>Ver regulamento completo</span>
      </Button>
    </div>
    <!-- DATES -->
    <section id="dates" class="py-3">
      <div class="container py-5">
        <div class="col-md-10 mx-auto d-flex flex-column flex-md-row justify-content-center justify-content-md-between text-center mt-3 text-white">
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">13/05</span>
            <p class="mb-0">
              <strong>Início</strong><br/>do evento
            </p>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">01/06</span>
            <p class="mb-0">
              <strong>Fim</strong><br/>do evento
            </p>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">06/06</span>
            <p class="mb-0">
              <strong>Deliberação</strong><br/>dos jurados
            </p>
          </div>
          <div class="col-md-3">
            <span class="d-block font-weight-bold font-size-large">20/06</span>
            <p class="mb-0">
              <strong>Anúncio</strong><br/>dos vencedores
            </p>
          </div>
        </div>
      </div>
    </section> <!-- END DATES -->
    <!-- CTA -->
    <section>
      <div class="container py-5 text-center">
        <h2 class="font-size-xLarge">Comece a participar <br/>agora mesmo</h2>
        <router-link
          :to="{ name: 'posts.create', query: { tags: 'meuamor' } }"
          target="_blank"
          class="btn btn-primary mt-2"
          v-if="authenticated"
        >
          Escrever texto
        </router-link>
        <Button
          class="btn btn-primary mt-2"
          v-b-modal.auth-modal
          v-else
        >
          Escrever texto
        </Button>
      </div>
    </section> <!-- END CTA -->
  </div>
</template>

<script>

import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import PostThumbCard from '@/components/post/PostThumbCard'

export default {
  components: {
    Button,
    PostThumbCard
  },
  metaInfo: {
    title: 'Evento #05 - Amor'
  },
  data () {
    return {
      aboutThemeVisible: false,
      rulesVisible: false,
      items: [
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/dIhIABOKZEAakn55XRH354ViiEEonYwwLiX2DfGw.jpg',
          slug: 'o-guarda-chuva-vermelho-1708',
          title: 'O Guarda Chuva Vermelho',
          status: 'published',
          user: {
            name: "Sandra O'Neill",
            username: 'sandra-oneill',
            avatar: 'https://cdn.scriv.com.br/storage/images/VFqyjJdXnhzMe5DRy59WRFudRMALZOzrMKbnSU6B.jpg'
          }
        },
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/NOmYGZYJBDSbrNIIo6Lok7Iga8mkZ5N5ESLKhOJC.jpg',
          slug: 'solidaonorocha',
          title: 'Solidão no Rocha',
          status: 'published',
          user: {
            name: 'Damiana Duarte',
            username: 'damianaduarte',
            avatar: 'https://cdn.scriv.com.br/storage/images/9z0qLDbDGEjC5t4fStwh0ZI9HGqYDA9RjYvubFDV.jpg'
          }
        },
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/KDg7eR5dQ39swAviL5hpvCSH29dU7bh6YapumQIP.jpg',
          slug: 'enfim-sua',
          title: 'Enfim Sua',
          status: 'published',
          user: {
            name: 'Maíra Gomes',
            username: 'mairagomes',
            avatar: 'https://cdn.scriv.com.br/storage/images/5Lt0v88Au296q7phcMN1Q7eTuqVJxSXi68tWTO1D.jpg'
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  },
  methods: {
    toggleTheme () {
      this.aboutThemeVisible = !this.aboutThemeVisible
    }
  }
}
</script>

<style lang="scss" scoped>

#lp-header {
  background: url('/images/events/05-amor/header-bg.jpg?v=1') center center no-repeat;
  background-size: cover;
  margin-top: -3rem !important;
  position: relative;

  h2 {
    color: #716b6a;
    text-shadow: 0 5px 0 rgba(238,91,69, 0.46);
    position: relative;
    display: inline-block;

    &::before {
      content: '';
      background: #ff9d8e;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 24px;
      z-index: -1;
    }
  }

  p {
    color: #372b2f;
  }

  .container {
    position: relative;
    z-index: 2;
  }
}

#buttons {
  margin-top: -22px;
  z-index: 3;
  position: relative;
}

#about-theme {
  height: auto;
  background: #eee;
  overflow: hidden;

  @include desktop {
    margin-top: -22px;
  }

  &.hidden {
    height: 0px;

    @include desktop {
      margin-top: 0;
    }
  }

  .post-card {
  -webkit-border-radius: $radius_regular;
  -moz-border-radius: $radius_regular;
  border-radius: $radius_regular;
  overflow: hidden;
  -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.3);
  background-color: #fff;
  position: relative;
  color: #fff;

  &:hover {
    .image-wrap {
      .image {
        transform: scale(1.1);
      }
    }
  }

  .image-wrap {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.25);
    }

    .image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      transition: all 0.6s ease-out;
    }

    .cover-sizing {
      opacity: 0;
    }

    &.has-cover {
      &::after {
        background: rgba(0,0,0,0.1);
      }
    }
  }

  .post-info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: left;
    padding: 15px;

    .post-title {

      h2 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: $font_size_regular;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
}
}

#steps {
  .step {
    position: relative;
    text-align: center;

    @include desktop {
      width: 25%;
    }

    &:last-child {
      &::after {
        display: none;
      }
    }

    &::after {
      content: '\f107';
      font-family: 'FontAwesome';
      font-size: 40px;
      color: $color2;
      position: absolute;
      bottom: -44px;
      left: calc(50% - 13px);

      @include tablet {
        content: '\f105';
        bottom: auto;
        top: 40px;
        left: auto;
        right: -25px;
      }

      @include desktop {
        right: -12px;
      }
    }
  }
}

#prizes, #judges {
  .author-image-circle.image-lg {
    width: 150px;
    height: 150px;

    @include tablet {
      width: 120px;
      height: 120px;
    }

    @include desktop {
      width: 150px;
      height: 150px;
    }
  }
}

#prizes {
  .prize-item {
    @include desktop {
      width: calc(100%/5);
    }
  }
}

#rules {
  background: url('/images/events/bg-paper.jpg?v=2') top center no-repeat;
  background-size: cover;

  ul {
    li {
      list-style: disc;
    }
  }
}

.read-more-rules {
  margin-top: -22px;
  margin-bottom: -22px;
  position: relative;
  z-index: 3;
}

#dates {
  background: url('/images/events/01-causos/dates-bg.jpg') center center no-repeat;
  background-size: cover;
}

::v-deep {
  .post-thumbs-carousel {
    .post-info {
      display: none;
    }
  }
}
</style>
